export default __webpack_public_path__ + "static/media/react.cb8eb538.png";